module.exports = __webpack_public_path__ + "media/images/labfilms-team-e51189720d5d89b6eb182c76fb600a27.png";